module.exports = __webpack_public_path__ + "img/images.12bc1a6a.svg";